import React, { useState, useEffect } from 'react';
import Preview from './components/Preview';
import ImagesUpload from './components/ImagesUpload';
import SpecialReserve from './components/SpecialReserve';
import PersonalDetails from './components/PersonalDetails';
import Academic from './components/Academic';
import Payment from '../Components/Payment/Payment';
import Address from './components/Address';

function PersonalInfo() {

    const [currentSection, setCurrentSection] = useState(parseInt(localStorage.getItem('currentSection'), 10) || 1);


    const handleNext = () => {
        setCurrentSection(currentSection + 1);
    };

    const handlePrevious = () => {
        setCurrentSection(currentSection - 1);
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     // console.log('Form submitted:', formData);
    // };

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="section">
            <br />
            <div className='statusBar'>
                <svg className='svgBar' xmlns="http://www.w3.org/2000/svg">
                    <line x1="2.5%" y1="40%" x2="12.5%" y2="40%" stroke={currentSection >= 1 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="14.5%" cy="40%" r="2%" stroke={currentSection > 1 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 1 ? "#018749" : "gray"} />
                    <text x="14.5%" y={windowWidth > 768 ? "80%" : "75%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Personal</text>
                    <text x="14.5%" y={windowWidth > 768 ? "100%" : "90%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Information</text>
                    <text x="14.4%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 1 ? "\u2713" : "1"}</text>

                    <line x1="16.5%" y1="40%" x2="26.5%" y2="40%" stroke={currentSection >= 2 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="28.5%" cy="40%" r="2%" stroke={currentSection > 2 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 2 ? "#018749" : "gray"} />
                    <text x="28.5%" y={windowWidth > 768 ? "80%" : "75%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Address</text>
                    <text x="28.5%" y={windowWidth > 768 ? "100%" : "90%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Information</text>
                    <text x="28.5%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 2 ? "\u2713" : "2"}</text>

                    <line x1="30.5%" y1="40%" x2="40.5%" y2="40%" stroke={currentSection >= 3 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="42.5%" cy="40%" r="2%" stroke={currentSection > 3 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 3 ? "#018749" : "gray"} />
                    <text x="42.5%" y={windowWidth > 768 ? "80%" : "75%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Academic</text>
                    <text x="42.5%" y={windowWidth > 768 ? "100%" : "90%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Information</text>
                    <text x="42.5%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 3 ? "\u2713" : "3"}</text>

                    <line x1="44.5%" y1="40%" x2="54.5%" y2="40%" stroke={currentSection >= 4 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="56.5%" cy="40%" r="2%" stroke={currentSection > 4 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 4 ? "#018749" : "gray"} />
                    <text x="56.5%" y={windowWidth > 768 ? "80%" : "75%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Special</text>
                    <text x="56.5%" y={windowWidth > 768 ? "100%" : "90%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Reservation</text>
                    <text x="56.5%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 4 ? "\u2713" : "4"}</text>

                    <line x1="58.5%" y1="40%" x2="68.5%" y2="40%" stroke={currentSection >= 5 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="70.5%" cy="40%" r="2%" stroke={currentSection > 5 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 5 ? "#018749" : "gray"} />
                    <text x="70.5%" y={windowWidth > 768 ? "90%" : "82.5%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Photo & Signature</text>
                    <text x="70.5%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 5 ? "\u2713" : "5"}</text>

                    <line x1="72.5%" y1="40%" x2="82.5%" y2="40%" stroke={currentSection >= 6 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="84.5%" cy="40%" r="2%" stroke={currentSection > 6 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 6 ? "#018749" : "gray"} />
                    <text x="84.5%" y={windowWidth > 768 ? "90%" : "82.5%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Preview</text>
                    <text x="84.5%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 6 ? "\u2713" : "6"}</text>

                    {/* <line x1="66.5%" y1="40%" x2="79%" y2="40%" stroke={currentSection >= 5 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                    <circle cx="81%" cy="40%" r="2%" stroke={currentSection > 5 ? "#018749" : "gray"} strokeWidth={windowWidth > 768 ? "2" : "1"} fill={currentSection > 5 ? "#018749" : "gray"} />
                    <text x="81%" y={windowWidth > 768 ? "90%" : "82.5%"} textAnchor="middle" fontSize="1vw" fontWeight="600">Preview</text>
                    <text x="81%" y={windowWidth > 768 ? "48%" : "45%"} textAnchor="middle" fontWeight="700" fontSize="1vw" fill='#fff'>{currentSection > 5 ? "\u2713" : "5"}</text> */}

                    <line x1="86.5%" y1="40%" x2="97.5%" y2="40%" stroke={currentSection > 6 ? "#0CAFFF" : "black"} strokeWidth={windowWidth > 768 ? "2" : "1"} />
                </svg>
            </div>
            <br />
            {currentSection === 1 && (
                <PersonalDetails handleNext={handleNext} />
            )}
            {currentSection === 2 && (
                <Address handleNext={handleNext} handlePrevious={handlePrevious} />
            )}
            {currentSection === 3 && (
                <Academic handleNext={handleNext} handlePrevious={handlePrevious} />
            )}
            {currentSection === 4 && (
                <SpecialReserve handlePrevious={handlePrevious} handleNext={handleNext} />
            )}
            {currentSection === 5 && (
                <ImagesUpload handleNext={handleNext} handlePrevious={handlePrevious} />
            )}
            {currentSection === 6 && (
                <Preview handleNext={handleNext} handlePrevious={handlePrevious} />
            )
            }
            {currentSection === 7 && (
                <Payment handlePrevious={handlePrevious} />
            )
            }
        </div >
    )
}

export default PersonalInfo;